export const questions: Array<[string, string]> = [
  [
    'Per chi è questa collezione?',
    'Per insegnanti di scienze, biologia, chimica e materie affini della scuola secondaria che vogliono lezioni di scienze forensi più chiare, rigorose e pronte all’uso.',
  ],
  ['In che formato ricevo il materiale?', 'In PDF digitali, da scaricare, stampare o proiettare in classe.'],
  ['Quando ricevo l’accesso?', 'Subito dopo il pagamento, via email.'],
  [
    'Serve una preparazione specifica in scienze forensi?',
    'No. Ogni volume spiega i concetti passo dopo passo, con esempi e attività pronte.',
  ],
  [
    'I contenuti sono adatti agli studenti?',
    'Sì. Tutti i casi sono fittizi e trattati in modo scientifico e rispettoso, senza immagini o dettagli cruenti.',
  ],
  ['C’è una garanzia?', 'Sì, 7 giorni: se il materiale non fa per te, ti rimborsiamo.'],
];
